import { blueyetiStates } from '@/utils/blueyetiStates'
import { sync } from 'vuex-pathify'
import '@/utils/pretty-checkbox/pretty-checkbox.scss';
import SimpleKeyboard from "./../SimpleKeyboard";
import VueCircle from 'vue2-circle-progress/src/index.vue'
import VueFriendlyIframe from 'vue-friendly-iframe';
import printJS from 'print-js';


//Vue.component('vue-friendly-iframe', VueFriendlyIframe);

import CheckBtn from './../../assets/appIcons/BTN_Check.svg';
import CrossBtn from './../../assets/appIcons/BTN_Cross.svg';
import FacebookBtn from './../../assets/appIcons/BTN_Facebook.svg';
import MailBtn from './../../assets/appIcons/BTN_Mail.svg';
import PrintBtn from './../../assets/appIcons/BTN_Print.svg';
import PublishAnim from './../../assets/appIcons/ASSET_Publish.svg';
import HomeBtn from './../../assets/appIcons/BTN_Home.svg';

import axios from 'axios'



export default {
  name: 'share-ui',
  mixins: [blueyetiStates],
  components: {
      CheckBtn, CrossBtn, FacebookBtn, MailBtn, PrintBtn, HomeBtn, SimpleKeyboard, PublishAnim, VueCircle, VueFriendlyIframe
  },
  props: {
     gifIsComputed: false,
},
  data () {
    return {
      // form:  '<script src="https://mfpembedcdnweu.azureedge.net/mfpembedcontweu/Embed.js" type="text/javascript"></script><link rel="stylesheet" type="text/css" href="https://mfpembedcdnweu.azureedge.net/mfpembedcontweu/Embed.css" /><script type = "text/javascript" >function renderSurvey(parentElementId,){var se = new SurveyEmbed("aLyce0rjkU-MQJZaipdaTpc2wQLyxmlMmmvT1aGdrFtUQjJOQVJEQVM0M1pKOVNLWjVLSUFFUDlLTy4u","https://forms.office.com/","https://mfpembedcdnweu.azureedge.net/mfpembedcontweu/");var context = {};se.renderInline(parentElementId, context);}</script>',
      byst_active_states: [],
      byst_active_all_states: true,
      byst_active_except: ["gallery/*"],
      email_ui_visible: false,
      email_valid: false,
      kbd_visible: false,
      upload_progress: 0,
      isSendingFile: false,
      emailSectionText1 : 'PARTAGEZ VOTRE CREATION PAR E-MAIL',
      emailSectionText2 : 'PARTAGEZ PAR E-MAIL ET PARTICIPEZ AU JEU CONCOURS',
      //reg: ""
      reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
    }

},
  computed: {
     // @see https://davestewart.github.io/vuex-pathify/#/api/component
     app_state: sync('app_state'),
     api_address:sync('api_address'),
     token:sync('token'),
     theme_id: sync('settings@theme_id'), //id thème
     privat_id: sync('settings@privat_id'), //id thème
     form:  sync('settings@form'),
     display_form:  sync('settings@display_form'),
     display_newsletter_checkbox:  sync('settings@display_newsletter_checkbox'),
     display_contest_checkbox:  sync('settings@display_contest_checkbox'),
     themeMainColor: sync('themeMainColor'),
     window_width: sync('message_width'),
     window_height: sync('message_height'),
     messageDataURL: sync('messageDataURL'),
     messageId: sync('messageId'),
     rgpd: sync('settings@rgpd'),
     email: sync('share@email'),
     contest: sync('share@contest'),
     newsletter: sync('share@newsletter'),
     formCompleted: sync('share@formCompleted'),
     shareFacebook: sync('share@facebook'),
     sharePrint: sync('share@print'),
     printerEnable: sync('settings@printer'),
     emailSectionText () {
        if(this.display_contest_checkbox)
            return this.emailSectionText2;
      else
         return this.emailSectionText1;
     },
     showForm() {
        if (this.byst_CompareCurrentStates(['custom/form'])) {
           this.$nextTick(() => {
             //console.log("iframe");
             var x = document.getElementById("shareFormParent");
             console.log(x);
             var iframe = document.getElementsByTagName("iframe")[0];
             console.log(iframe);
             iframe.onload = () => {
                console.log('iframe is completely loaded');
             }

    })
           return true;
        } else {
           return false;
        }
     },


     //...sync('theme/*'),
     log: function () {
        // `this` pointe sur l'instance vm
        //console.log(get('thiswatermark)
     }

     //console.log(watermark)

     //  todos: {
     //  ...sync("todo/todo")
     //},

  },

  mounted () {
     //console.log("appstate " + this.byst_app_state);
     this.shareFacebook = false;
     this.sharePrint = false;
     this.email = "";
     this.newsletter = false;
     this.contest = false;
     //console.log("messageDataURL " + this.messageDataURL);

     // var mydiv = document.getElementById("surveyDiv");
     //
     // mydiv.innerHTML = this.form;
     // var scripts = mydiv.getElementsByTagName("script");
     // for (var i = 0; i < scripts.length; i++) {
     //    eval(scripts[i].innerText);
     // }

  },
  timers: {
     publishTimer: { time: 2000, autostart: false },
  },
  methods: {
     onGifCompute: function(e){
        console.log("gif creation " + e * 100);
           //this.gifProgress
           this.$refs.shareGifProgressCircle.updateProgress(e * 100);
           this.$refs.shareGifProgressCircle.updateFill(this.themeMainColor);
           //this.gifIsComputed = false;
     },
     publishTimer: function(e){
        this.$timer.stop('publishTimer')
        if (this.isSendingFile) {
           if (this.display_form) {
             this.byst_SetState('custom/form');
          } else {
             this.gotoGallery();

          }
        }
       },
       onSend: function(){
        this.byst_SetState('custom/publish');
        console.log('publishanim ' + this.$refs.publishanim);
        this.$timer.stop('publishTimer');

        this.isSendingFile = false;
        this.upload_progress = 0;
        this.$refs.uploadProgressCircle.updateFill(this.themeMainColor);
        var cid = this.currentID;
        var fileData = this.messageDataURL;
        const that = this;

        axios.post( this.api_address + 'message', {
           token:that.token,
           type: 'image',
           nb_images: 1,
           width: that.message_width,
           height: that.message_height,
           source: 'desk',
           theme: that.theme_id,
           privat_id: that.privat_id,
           portrait: false,
           email: that.email,
           facebook: that.shareFacebook,
           print: that.sharePrint,
           form: that.formCompleted,
           newsletter: that.newsletter,
           contest: that.contest
        }, {
            headers: {
               'Content-Type': 'application/json',
               Authorization: `Bearer ${process.env.VUE_APP_PUBLIC_API_TOKEN}`
            }
         })
        .then(function (response) {
           console.log("response " + response.data);
           // console.log(response);
           // console.log(response.data);
           // console.log(JSON.parse(response.data).id);
           cid = JSON.parse(response.data).id;
           that.messageId = cid;
           const config = {
              onUploadProgress: function(progressEvent) {
                 //that.upload_progress = Math.round((progressEvent.loaded * 100) / progressEvent.total)
                 //console.log(that.upload_progress)
                 that.$refs.uploadProgressCircle.updateProgress((progressEvent.loaded * 100) / progressEvent.total);
                 that.$refs.uploadProgressCircle.updateFill(that.themeMainColor);
                 that.$emit('resetTimeOutTimer');
              },
              headers: {
                 'Content-Type': 'application/json',
                  Authorization: `Bearer ${process.env.VUE_APP_PUBLIC_API_TOKEN}`
              }
           }



           axios.post(that.api_address + 'file', {
              token:that.token,
              id: JSON.parse(response.data).id,
              file: fileData,
           }, config)
           .then(function (response) {
             console.log("file sent " + that.messageId);
             that.$localStorage.set('lastMessageID', that.messageId)
             that.isSendingFile = true;
             that.$refs.publishanim.setCurrentTime(0);
             that.$timer.start('publishTimer');
             // if (!that.timers.publishTimer.isRunning)
             //    that.gotoGallery();
           })
           .catch(function (error) {
             console.log(error);
             that.isSendingFile = false;
             // if (!that.timers.publishTimer.isRunning)
             //that.gotoGallery();
           });

           if(that.printerEnable && that.sharePrint)
            print()


        })
        .catch(function (error) {
           console.log(error);
        });


        //this.$refs.publishanim.beginElement();
     },
     resetTimeOutTimer: function(){
        this.$emit('resetTimeOutTimer');
     },
      gotoGallery: function(e){
         location.reload();
      },


     // gotoGallery: function(e){
     //
     //    if(!this.email_valid || !this.email_ui_visible) {
     //       this.email = "";
     //       this.newsletter = false;
     //       this.contest = false;
     //    }
     //
     //    const that = this;
     //    axios.post(this.api_address + 'message', {
     //       token:this.token,
     //       id: that.messageId,
     //       email: that.email,
     //       facebook: that.shareFacebook,
     //       print: that.sharePrint,
     //       form: that.formCompleted,
     //       newsletter: that.newsletter,
     //       contest: that.contest
     //    })
     //    .then(function (response) {
     //       console.log("message envoyé " + JSON.parse(response.data).id);
     //       // console.log(response);
     //       // console.log(response.data);
     //       // console.log(JSON.parse(response.data).id);
     //       //cid = response.data.id;
     //       location.reload();
     //
     //    })
     //    .catch(function (error) {
     //       console.log(error);
     //       location.reload();
     //
     //
     //    });
     //
     //
     //   //this.byst_SetState('gallery');
     // },
     toogleEmailUI: function(){
        this.email_ui_visible = !this.email_ui_visible;
        //this.email_ui_visible ? this.email = "popbook@blueyeti.fr":this.email = "";
     },
     isEmailValid: function() {
        this.email_valid = (this.email == "")? "" : (this.reg.test(this.email));
        return this.email_valid ? 'has-success' : 'has-error';
     },
     toogleFaceBook: function(){
        this.shareFacebook = !this.shareFacebook;
        console.log("facebook " + this.shareFacebook);
     },
     tooglePrint: function(){
        this.sharePrint = !this.sharePrint;
        console.log("print " + this.sharePrint);
     },
     print: function(){
        console.log("print");
        printJS({printable: this.messageDataURL, type: 'image', base64: true})
        // let windowContent = '<!DOCTYPE html>';
        // windowContent += '<html>';
        // windowContent += '<head><title>Print canvas</title></head>';
        // windowContent += '<body>';
        // windowContent += '<img src="' + this.messageDataURL + '">';
        // windowContent += '</body>';
        // windowContent += '</html>';
        //
        // const printWin = window.open('', '', 'width=' + this.message_width + ',height=' + this.message_height);
        // printWin.document.open();
        // printWin.document.write(windowContent);
        //
        // printWin.document.addEventListener('load', function() {
        //     printWin.focus();
        //     printWin.print();
        //     printWin.document.close();
        //     printWin.close();
        // }, true);
     },
     // keyboard methods
     showKbd(val) {
       this.kbd_visible = val;
       console.log("kbd_visible ", this.kbd_visible);
     },
     onChange(input) {
       this.email = input;
       console.log("onChange ", this.email);
     },
     onKeyPress(button) {
       console.log("button", button);
     },
     onInputChange(input) {
       this.email = input.target.value;
       console.log("onInputChange ", this.email);
    },
    blurInput() {
      this.$refs.emailInput.blur();
   },

   renderForm(){
      // var mydiv = document.getElementById("renderSurveyDiv");
      //
      // mydiv.innerHTML = '<script>console.log("FORM SCRIPT2"); renderSurvey("surveyDiv");</script>';
      // var scripts = mydiv.getElementsByTagName("script");
      // for (var i = 0; i < scripts.length; i++) {
      //   eval(scripts[i].innerText);
      //}

   }


  }
}
